import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const RegistrationStatusChartsDataContext = createContext();

const RegistrationStatusChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.REGISTRATION_SITUATION_PEOPLE,
            url: 'governanceroom/dashboard/unifiedregistry/people/registration-situation'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              bolsaFamiliaRegister: data?.bolsaFamiliaRegister ?? [],
              childLabor: data?.childLabor ?? [],
              homeless: data?.homeless ?? [],
              peopleRegistered: data?.peopleRegistered ?? [],
              certificatePresented: data?.certificatePresented ?? [],
              registrationStatus: data?.registrationStatus ?? []
          }
        : {
              bolsaFamiliaRegister: [],
              childLabor: [],
              homeless: [],
              peopleRegistered: [],
              certificatePresented: [],
              registrationStatus: []
          };

    return (
        <RegistrationStatusChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RegistrationStatusChartsDataContext.Provider>
    );
};

export default RegistrationStatusChartsDataProvider;
